<template>
    <!-- 客户数据操作 -->
    <div>
        <customerBank ref="customerBank" @returnBank="returnBank"></customerBank>
        <customerCertificates ref="customerCertificates" @returnlicence="returnlicence"></customerCertificates>
        <salesSettingUnitForm ref="salesSettingUnitForm" @pushData="pushData"></salesSettingUnitForm>

        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :istitle="'客户操作记录'" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box" v-if="scope.index == -1">
                                <el-timeline v-if="reviewNodeList.length > 0">
                                    <el-timeline-item v-for="(nodeValue, nodeKey) in reviewNodeList" :key="nodeKey" :timestamp="$common.getLocalTime(nodeValue.createTime, true)" placement="top"
                                        :icon="nodeValue.auditId == null ? 'el-icon-close' : 'el-icon-check'" :type="nodeValue.auditId == null ? 'danger' : 'success'">
                                        <el-card v-if="nodeKey == 0">
                                            <h4>{{ nodeValue.appName }}</h4>
                                            <p>发起人：{{ nodeValue.orderCreaterName }}</p>
                                        </el-card>
                                        <el-card v-else>
                                            <h4>{{ nodeValue.nodeName }}</h4>
                                            <p>操作人：{{ nodeValue.opmName }}</p>
                                            <p v-if="nodeValue.auditState != null" :class="nodeValue.auditState == 0 ? 'auditing_text_red ' : 'auditing_text_green'">
                                                操作状态：{{ nodeValue.auditState == 0 ? '审核驳回' : '审核通过' }}
                                            </p>
                                            <p>审核意见：{{ nodeValue.auditRemark ? nodeValue.auditRemark : '暂无信息' }}</p>
                                        </el-card>
                                    </el-timeline-item>
                                </el-timeline>
                                <div v-else style="text-align:center">暂无数据</div>
                            </div>
                            <div class="table_content_box">
                                <!-- 主信息 -->
                                <div v-if="scope.index == 0">
                                    <el-button v-if="dataActionBox.actionType == 0 && scope.index == 0" id="operateBtn" type="primary" size="small" class="btn" @click="extractCustom()">提取</el-button>
                                    <el-form label-width="140px" label-position="right" size="mini" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" :disabled="dataActionBox.actionType > 1" :show-message="false">
                                        <el-row>
                                            <el-form-item v-if="dataActionBox.actionType >= 1" label="单位编号" prop="cmCode">
                                                <label slot="label" :style="$common.labelStyle('单位编号')" v-html="$common.htmlLabel('单位编号')"></label>
                                                <template>
                                                    <el-input disabled v-model.trim="sendDataInfo.cmCode"></el-input>
                                                </template>
                                            </el-form-item>
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item v-if="formOneValue.isShow == 1" :key="formOneKey" :id="formOneValue.entityField" :label="formOneValue.showField" :prop="formOneValue.entityField"
                                                    :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <el-tooltip class="item"
                                                        :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' || sendDataInfo[formOneValue.entityField].length <= 9 ? true : false"
                                                        effect="dark" :content="getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField, formOneValue.fieldType, formOneValue.formatterContent)" placement="bottom-start">
                                                        <!-- 单位类型 -->
                                                        <el-select v-if="formOneValue.entityField == 'cmIntype'" @change="changesmIntype" filterable v-model="sendDataInfo[formOneValue.entityField]" style="width: 100%;"
                                                            :disabled="formOneValue.isChange == 0" clearable>
                                                            <el-option v-for="(values) in dictionariesDatas" :key="values.diId" :label="values.diName" :value="values.diValue"></el-option>
                                                        </el-select>
                                                        <!-- 编号分类 -->
                                                        <el-select clearable v-else-if="formOneValue.entityField == 'codeType'" filterable v-model="sendDataInfo[formOneValue.entityField]" :disabled="formOneValue.isChange == 0||(formOneValue.isUpdate == 0&&dataActionBox.actionType!=0)">
                                                            <el-option v-for="(dictionariesValue, dictionariesKey) in codeClassify" :key="dictionariesKey" :label="dictionariesValue.codeType" :value="dictionariesValue.codeType">
                                                            </el-option>
                                                        </el-select>
                                                        <!-- 控销类型 -->
                                                        <el-select v-if="formOneValue.entityField == 'controlType'" filterable v-model="sendDataInfo[formOneValue.entityField]" style="width: 100%;" :disabled="formOneValue.isChange == 0"
                                                            clearable>
                                                            <el-option v-for="(values) in controlTypeList" :key="values.diId" :label="values.diName" :value="values.diValue"></el-option>
                                                        </el-select>
                                                        <el-select size="mini" filterable v-else-if="formOneValue.fieldType == 'formatter'" @change="((val) => { handleChange(val, formOneValue.fieldEntity) })"
                                                            v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                            <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.key" :value="matItem.value"></el-option>
                                                        </el-select>
                                                        <el-cascader ref="cascader" :props="{ emitPath: false }" v-else-if="formOneValue.entityField == 'areaCode'" style="width: 100%;" :options="options"
                                                            v-model="sendDataInfo[formOneValue.entityField]" @change="(value)=>{handleAddChange(value,formOneValue.setField)}" clearable filterable>
                                                        </el-cascader>
                                                        <!-- 营业期限 -->
                                                        <df-date v-else-if="formOneValue.fieldType == 'date'" :isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model="sendDataInfo[formOneValue.entityField]" />
                                                        <el-input v-else-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                            @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" :disabled="formOneValue.isChange == 0">
                                                            <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                :disabled="formOneValue.isChange == 0">
                                                            </el-button>
                                                        </el-input>
                                                        <!-- 价格策略 -->
                                                        <el-input v-else-if="formOneValue.entityField == 'levleId'" placeholder="请选择价格策略" v-model="sendDataInfo.levleName" @focus="openSearch(formOneValue.searchId)"></el-input>

                                                        <!-- 注册地址 -->
                                                        <el-input
                                                            v-else-if="formOneValue.entityField == 'cmRegaddres' || formOneValue.entityField == 'cmWareaddress' || formOneValue.entityField == 'cmRemark' || formOneValue.entityField == 'cmPlace' || formOneValue.entityField == 'cmBank'|| formOneValue.entityField == 'baStoreaddress'"
                                                            v-model="sendDataInfo[formOneValue.entityField]" type="textarea" maxlength="500" @blur="blurClick(formOneValue.entityField)"></el-input>
                                                        <!-- 信贷期 -->
                                                        <el-input v-else-if="formOneValue.entityField == 'cfiCreditperiod'" v-model="sendDataInfo[formOneValue.entityField]" type="number" :disabled="formOneValue.isChange == 0" clearable>
                                                            <template slot="append">天</template>
                                                        </el-input>
                                                        <!-- 信贷额 -->
                                                        <el-input v-else-if="formOneValue.entityField == 'cfiCreditamount'" v-model="sendDataInfo[formOneValue.entityField]" type="number" :disabled="formOneValue.isChange == 0" clearable>
                                                            <template slot="append">元</template>
                                                        </el-input>
                                                        <el-input v-else-if="formOneValue.entityField == 'cmSocialcode'" @blur="blurChange(formOneValue.entityField)" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                            :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange == 0" clearable>
                                                            <template slot="append"><span style="color: red;">{{
                                             sendDataInfo[formOneValue.entityField] == '' ||
                                                sendDataInfo[formOneValue.entityField] == null
                                                || sendDataInfo[formOneValue.entityField] == undefined ? 0
                                                : sendDataInfo[formOneValue.entityField].length
                                                }}位</span></template>
                                                        </el-input>
                                                        <el-input v-else v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange == 0" clearable>
                                                        </el-input>
                                                    </el-tooltip>
                                                </el-form-item>
                                            </template>
                                        </el-row>

                                    </el-form>
                                    <el-form ref="sendDataInfo1" :model="obj" :disabled="dataActionBox.actionType > 1" :show-message="false">
                                        <el-form-item v-for="(formOneValue, formOneKey) in dataList" :key="formOneKey" :prop="formOneValue.entityField == 'cmManrange' ? 'cmManrangeValues' : 'cmTrerangeValues'"
                                            :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                            <div id="cmManrange" v-if="formOneValue.entityField == 'cmManrange'">
                                                <div class="cmTitle"><span style="color: red;padding-right: 5px;" v-if="formOneValue.isRequired == 1">*</span>{{ formOneValue.showField }}
                                                </div>
                                                <div class="cmContent">
                                                    <el-button v-if="dataActionBox.actionType < 2" class="cmButton" @click="openRange('经营范围', 'cmManrange')" type="info" plain size="mini">选择经营范围</el-button>
                                                    <el-input type="textarea" v-model="obj.cmManrangeValues" readonly>
                                                    </el-input>
                                                </div>
                                            </div>
                                            <div id="cmTrerange" v-else-if="formOneValue.entityField == 'cmTrerange'">
                                                <div class="cmTitle"><span style="color: red;padding-right: 5px;" v-if="formOneValue.isRequired == 1">*</span>{{ formOneValue.showField }}
                                                </div>
                                                <div class="cmContent">
                                                    <el-button v-if="dataActionBox.actionType < 2" class="cmButton" @click="openRange('诊疗范围', 'cmTrerange')" type="info" plain size="mini">选择诊疗范围</el-button>
                                                    <el-input type="textarea" v-model="obj.cmTrerangeValues" readonly>
                                                    </el-input>
                                                </div>
                                            </div>
                                        </el-form-item>
                                    </el-form>
                                </div>
                                <!-- 证照信息 -->
                                <div v-if="scope.index == 1">
                                    <div id="operateBtn" v-if="dataActionBox.actionType < 2">
                                        <el-checkbox-group v-model="zzList" style="display: flex;align-items: center;flex-wrap: wrap;">
                                            <div v-for="(item, index) in LicensetypeList" :key="index" style="width: 250px;padding-left: 15px;position: relative;">
                                                <span v-if="item.isBT == 1" style="color:red;" class="xing">*</span>
                                                <span v-if="item.isKX == 1" style="color:#409EFF;" class="xing">*</span>
                                                <el-checkbox style="width: 220px;" :label="item.diName"></el-checkbox>
                                            </div>
                                        </el-checkbox-group>
                                    </div>
                                    <el-table v-if="scope.row" :height="mxHeight" :data="sendDataInfo.cuslicencelinfos" border style="width: 100%" size="mini">
                                        <template v-for="(tableValye, tableKey) in scope.row.jurconfigform">
                                            <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField"
                                                :show-overflow-tooltip="tableValye.entityField == 'uploadVoList' ? false : true" :min-width="dealMinWidth(tableValye.entityField)"
                                                :fixed="tableValye.entityField == 'uploadVoList' ? 'right' : false">
                                                <template slot-scope="scope">
                                                    <div v-if="dataActionBox.actionType == 2 || dataActionBox.actionType == 4">
                                                        <span v-if="tableValye.isReserved == 0">
                                                            <span v-if="tableValye.entityField == 'cliRedate'">
                                                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                                            </span>
                                                            <span v-else-if="tableValye.fieldType == 'date'">
                                                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                                            </span>
                                                            <div v-else-if="tableValye.entityField == 'uploadVoList'" class="uploadList">
                                                                <cusImage class="image" v-for="(val, key) in scope.row.uploadVoList" :key="key" style="width: 30px; height: 30px;margin-top: 5px;" :src="val.url"
                                                                    :preview-src-list="getUrl(scope.row.uploadVoList)">
                                                                </cusImage>
                                                            </div>
                                                            <span v-else-if="tableValye.entityField == 'lityId'">{{scope.row[tableValye.entityField] }}</span>
                                                            <span v-else-if="tableValye.entityField == 'isIntercept'">
                                                                <el-tag v-if="scope.row[tableValye.entityField] == 1">是</el-tag>
                                                                <el-tag type="warning" v-else-if="scope.row[tableValye.entityField] == 0">否</el-tag>
                                                            </span>
                                                            <span v-else-if="tableValye.fieldType == 'formatter'">
                                                                {{ getValue(scope.row[tableValye.entityField], tableValye.entityField, tableValye.fieldType, tableValye.formatterContent)}}
                                                            </span>
                                                            <span v-else-if="tableValye.entityField == 'cliScope'" style="color: #409EFF;cursor: pointer;" @click="cliScopeClick(1,tableValye.entityField,scope.$index)">
                                                                {{scope.row[tableValye.entityField]==""||scope.row[tableValye.entityField]==null?'/':scope.row[tableValye.entityField]}}
                                                            </span>
                                                            <span v-else>
                                                                {{ scope.row[tableValye.entityField] }}
                                                            </span>
                                                        </span>
                                                        <span v-if="tableValye.isReserved == 1">
                                                            <span v-if="tableValye.operatType == 0">{{ scope.row[tableValye.entityField]}}</span>
                                                            <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                                                        </span>
                                                    </div>
                                                    <div v-else>
                                                        <!-- 系统字段 -->
                                                        <div v-if="tableValye.isReserved == 0">
                                                            <df-date :isType="true" :isShowLong="false" :isdisabled="tableValye.isChange == 0" v-if="tableValye.entityField == 'cliRedate'"
                                                                v-model="sendDataInfo.cuslicencelinfos[scope.$index][tableValye.entityField]" />
                                                            <df-date :isType="true" :isdisabled="tableValye.isChange == 0" v-else-if="tableValye.fieldType == 'date'"
                                                                v-model="sendDataInfo.cuslicencelinfos[scope.$index][tableValye.entityField]" />
                                                            <ul v-else-if="tableValye.entityField == 'uploadVoList'" class="uploadList">
                                                                <li v-for="(val, key) in scope.row.uploadVoList" :key="key" class="image">
                                                                    <i class="el-icon-error del" @click="delRemove(scope.$index, key)"></i>
                                                                    <cusImage style="width: 30px; height: 30px;margin-top: 5px;" :src="val.url" :preview-src-list="getUrl(scope.row.uploadVoList)">
                                                                    </cusImage>
                                                                </li>
                                                            </ul>
                                                            <!-- 证照类型 -->
                                                            <span v-else-if="tableValye.entityField == 'lityId'">{{sendDataInfo.cuslicencelinfos[scope.$index][tableValye.entityField]}}</span>

                                                            <!-- 是否拦截 -->
                                                            <el-radio-group v-else-if="tableValye.entityField == 'isIntercept'" :disabled="tableValye.isChange == 0"
                                                                v-model="sendDataInfo.cuslicencelinfos[scope.$index][tableValye.entityField]">
                                                                <el-radio-button label="0">否</el-radio-button>
                                                                <el-radio-button label="1">是</el-radio-button>
                                                            </el-radio-group>
                                                            <el-select filterable size="mini" v-else-if="tableValye.fieldType == 'formatter'" v-model="sendDataInfo.cuslicencelinfos[scope.$index][tableValye.entityField]" placeholder="请选择">
                                                                <el-option v-for="matItem in JSON.parse(tableValye.formatterContent)" :key="matItem.value" :label="matItem.value" :value="matItem.value"></el-option>
                                                            </el-select>
                                                            <!-- 备注 -->
                                                            <el-input v-else-if="tableValye.entityField == 'remark'" type="textarea" v-model.trim="sendDataInfo.cuslicencelinfos[scope.$index][tableValye.entityField]"
                                                                maxlength="200"></el-input>
                                                            <el-input v-else-if="tableValye.entityField == 'cliTernumber'" v-model.trim="sendDataInfo.cuslicencelinfos[scope.$index][tableValye.entityField]"
                                                                :maxlength="$store.state.inputLength" clearable>
                                                                <template slot="append">
                                                                    <span style="color: red;">
                                                                        {{sendDataInfo.cuslicencelinfos[scope.$index][tableValye.entityField]==''||sendDataInfo.cuslicencelinfos[scope.$index][tableValye.entityField]==null||sendDataInfo.cuslicencelinfos[scope.$index][tableValye.entityField]==undefined ? 0:sendDataInfo.cuslicencelinfos[scope.$index][tableValye.entityField].length}}位
                                                                    </span>
                                                                </template>
                                                            </el-input>
                                                            <span v-else-if="tableValye.entityField == 'cliScope'" style="color: #409EFF;cursor: pointer;" @click="cliScopeClick(0,tableValye.entityField,scope.$index)">
                                                                {{scope.row[tableValye.entityField]==""||scope.row[tableValye.entityField]==null?'/':scope.row[tableValye.entityField]}}
                                                            </span>
                                                            <el-input v-else :id="tableValye.entityField" v-model="sendDataInfo.cuslicencelinfos[scope.$index][tableValye.entityField]" clearable></el-input>

                                                        </div>
                                                        <!-- 扩展字段 -->
                                                        <div v-if="tableValye.isReserved == 1">

                                                            <!-- 自填 -->
                                                            <el-input v-model.trim="sendDataInfo.cuslicencelinfos[scope.$index][tableValye.entityField]" v-if="tableValye.operatType == 0" :maxlength="$store.state.inputLength"
                                                                clearable></el-input>
                                                            <!-- 选择数据来源 -->
                                                            <el-input v-model.trim="sendDataInfo.cuslicencelinfos[scope.$index][tableValye.entityField]" v-else :maxlength="$store.state.inputLength" clearable></el-input>
                                                        </div>
                                                    </div>

                                                </template>
                                            </el-table-column>
                                        </template>
                                        <el-table-column fixed="right" label="操作" :width="printScanShow?380:300" v-if="dataActionBox.actionType != 2 && dataActionBox.actionType != 4">
                                            <template slot-scope="scope">
                                                <input style="display: none;" type="file" id="recordExcel" accept="image/*" multiple name="recordExcel" @change="(e) => { fileUpload(e.target.files, e.target.files.length, 0, e) }" />
                                                <label for="recordExcel" class="image_label" @click="eventIndex = scope.$index">上传</label>
                                                <el-button type="primary" @click="showUploadDialog(scope.$index)">拖拽上传</el-button>
                                                <el-button @click.stop="openFile1(0), (eventIndex = scope.$index)" type="primary" size="mini">高拍仪</el-button>
                                                <el-button v-if="printScanShow" @click.stop="openFile1(1), eventIndex = scope.$index" type="primary" size="mini">扫描仪</el-button>
                                                <el-button @click="delCertofocates(scope.row)" type="danger" size="mini">删除</el-button>
                                                <el-button type="primary" size="mini" @click="copyClick(scope.row)">复制</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <!-- 对方业务员信息 -->
                                <div v-if="scope.index == 2&&componentType == 'GSP'">
                                    <div id="operateBtn" v-if="dataActionBox.actionType < 2">
                                        <el-button type="primary" size="mini" @click="addLicense()">
                                            新增</el-button>
                                        <el-button type="primary" size="mini" @click="updateLicense()">修改</el-button>
                                        <el-button type="primary" size="mini" @click="delLicense()">删除</el-button>
                                    </div>
                                    <el-table :key="tableNum" v-if="scope.row" :data="sendDataInfo.salesDataList" border style="width: 100%" size="mini" :height="mxHeight">
                                        <el-table-column align="center" label="选择操作" width="80" v-if="dataActionBox.actionType < 2">
                                            <template slot-scope="scope">
                                                <el-radio v-model="selectSalesIndex" :label="scope.$index" border size="mini">
                                                    <i class="el-icon-thumb"></i>
                                                </el-radio>
                                            </template>
                                        </el-table-column>
                                        <template v-for="(tableValye, tableKey) in scope.row.jurconfigform">
                                            <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip
                                                :min-width="tableValye.fieldWeight">
                                                <template slot="header">
                                                    <div>
                                                        <el-tooltip :content="tableValye.showField" placement="top">
                                                            <div class="long_title"><span>{{ tableValye.showField }}</span>
                                                            </div>
                                                        </el-tooltip>
                                                    </div>
                                                </template>
                                                <template slot-scope="scope">
                                                    <template v-if="tableValye.fieldType == 'date'">
                                                        <span v-if="scope.row[tableValye.entityField]">
                                                            {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                                        </span>
                                                    </template>
                                                    <el-tag v-else-if="tableValye.entityField == 'isIntercept'" size="mini">
                                                        {{ getValue(scope.row[tableValye.entityField], tableValye.entityField, tableValye.fieldType, tableValye.formatterContent)}}</el-tag>
                                                    <el-tag size="mini" v-else-if="tableValye.fieldType == 'formatter'">
                                                        {{ getValue(scope.row[tableValye.entityField], tableValye.entityField, tableValye.fieldType, tableValye.formatterContent)}}
                                                    </el-tag>
                                                    <div v-else-if="tableValye.entityField == 'filePath'">
                                                        <div v-if="scope.row.filePath == null || scope.row.filePath == ''">
                                                        </div>
                                                        <div v-else v-for="(item, indexImg) in $common.getFileAddressARR(scope.row.filePath.split(',')) " :key="indexImg" style="float: left;">
                                                            <cusImage style="width: 30px; height: 30px;margin-top: 5px;" :src="item" :preview-src-list="$common.getFileAddressARR(scope.row.filePath.split(','))">
                                                            </cusImage>
                                                        </div>
                                                    </div>
                                                    <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                                                </template>
                                            </el-table-column>
                                        </template>
                                        <el-table-column align="center" type="expand" label="委托明细" height="100%" width="100">
                                            <template slot-scope="props">
                                                <!-- 委托明细 -->
                                                <div class="mxBox">
                                                    <el-divider content-position="left">委托明细</el-divider>
                                                    <el-table size="mini" border :data="props.row.descibSalesplicencedetailVo" style="width: 100%" :row-class-name="tableRowClassName">
                                                        <el-table-column prop="bgmName" label="通用名称" show-overflow-tooltip>
                                                        </el-table-column>
                                                        <el-table-column prop="mne" label="助记码" show-overflow-tooltip></el-table-column>
                                                        <el-table-column prop="spec" label="规格" show-overflow-tooltip></el-table-column>
                                                        <el-table-column prop="manufacturer" label="生产厂商" show-overflow-tooltip>
                                                        </el-table-column>
                                                        <el-table-column prop="placeorigin" label="产地" show-overflow-tooltip>
                                                        </el-table-column>
                                                    </el-table>
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <!-- 收货地址信息 -->
                                <div v-if="scope.index == 2&&componentType != 'GSP'">
                                    <div id="operateBtn" v-if="dataActionBox.actionType < 2">
                                        <el-button type="primary" size="mini" @click="addAddress()">
                                            新增</el-button>
                                        <el-button type="primary" size="mini" @click="delAddress()">删除</el-button>
                                    </div>
                                    <el-table :key="tableNum" v-if="scope.row" :data="sendDataInfo.descibCusAddress" border style="width: 100%" size="mini" :height="mxHeight">
                                        <el-table-column align="center" label="选择操作" width="80" v-if="dataActionBox.actionType < 2">
                                            <template slot-scope="scope">
                                                <el-radio v-model="selectAddressIndex" :label="scope.$index" border size="mini">
                                                    <i class="el-icon-thumb"></i>
                                                </el-radio>
                                            </template>
                                        </el-table-column>
                                        <template v-for="(tableValye, tableKey) in scope.row.jurconfigform">
                                            <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip
                                                :min-width="tableValye.fieldWeight">
                                                <template slot-scope="scope">
                                                    <div v-if="dataActionBox.actionType < 2&&tableValye.isChange==1">
                                                        <el-cascader ref="cascader1" :props="{ emitPath: false }" v-if="tableValye.entityField == 'areaCode'" style="width: 100%;" :options="options"
                                                            v-model="scope.row[tableValye.entityField]" @change="(value)=>{handleDetailsChange(value,scope.$index)}" clearable filterable>
                                                        </el-cascader>
                                                        <el-select size="mini" filterable v-else-if="tableValye.fieldType == 'formatter'" v-model="scope.row[tableValye.entityField]" placeholder="请选择">
                                                            <el-option v-for="matItem in JSON.parse(tableValye.formatterContent)" :key="matItem.key" :label="String(Number(matItem.key)) == 'NaN' ? matItem.key : matItem.value"
                                                                :value="String(Number(matItem.key)) == 'NaN' ? matItem.value : matItem.key"></el-option>
                                                        </el-select>
                                                        <el-input v-else style="width: 100%;" v-model="scope.row[tableValye.entityField]" clearable></el-input>
                                                    </div>
                                                    <div v-else>
                                                        <el-tag v-if="tableValye.fieldType == 'formatter'">
                                                            {{ getValue(scope.row[tableValye.entityField], tableValye.entityField, tableValye.fieldType, tableValye.formatterContent)}}
                                                        </el-tag>
                                                        <span v-else-if="tableValye.entityField == 'areaCode'">{{ scope.row.caiProvince }} {{ scope.row.caiCity }} {{ scope.row.caiArea }}</span>
                                                        <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                        </template>
                                    </el-table>
                                </div>
                                <!-- 收货地址信息 -->
                                <div v-if="scope.index == 3">
                                    <div id="operateBtn" v-if="dataActionBox.actionType < 2">
                                        <el-button type="primary" size="mini" @click="addAddress()">
                                            新增</el-button>
                                        <el-button type="primary" size="mini" @click="delAddress()">删除</el-button>
                                    </div>
                                    <el-table :key="tableNum" v-if="scope.row" :data="sendDataInfo.descibCusAddress" border style="width: 100%" size="mini" :height="mxHeight" @row-click="rowClick">
                                        <el-table-column align="center" label="选择操作" width="80" v-if="dataActionBox.actionType < 2">
                                            <template slot-scope="scope">
                                                <el-radio v-model="selectAddressIndex" :label="scope.$index" border size="mini">
                                                    <i class="el-icon-thumb"></i>
                                                </el-radio>
                                            </template>
                                        </el-table-column>
                                        <template v-for="(tableValye, tableKey) in scope.row.jurconfigform">
                                            <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip
                                                :min-width="tableValye.fieldWeight">
                                                <template slot-scope="scope">
                                                    <div v-if="dataActionBox.actionType < 2&&tableValye.isChange==1">
                                                        <el-cascader ref="cascader1" :props="{ emitPath: false }" v-if="tableValye.entityField == 'areaCode'" style="width: 100%;" :options="options"
                                                            v-model="scope.row[tableValye.entityField]" @change="(value)=>{handleDetailsChange(value,scope.$index)}" clearable filterable>
                                                        </el-cascader>
                                                        <el-select size="mini" filterable v-else-if="tableValye.fieldType == 'formatter'" v-model="scope.row[tableValye.entityField]" placeholder="请选择">
                                                            <el-option v-for="matItem in JSON.parse(tableValye.formatterContent)" :key="matItem.key" :label="String(Number(matItem.key)) == 'NaN' ? matItem.key : matItem.value"
                                                                :value="String(Number(matItem.key)) == 'NaN' ? matItem.value : matItem.key"></el-option>
                                                        </el-select>
                                                        <el-input v-else style="width: 100%;" v-model="scope.row[tableValye.entityField]" clearable></el-input>
                                                    </div>
                                                    <div v-else>
                                                        <el-tag v-if="tableValye.fieldType == 'formatter'">
                                                            {{ getValue(scope.row[tableValye.entityField], tableValye.entityField, tableValye.fieldType, tableValye.formatterContent)}}
                                                        </el-tag>
                                                        <span v-else-if="tableValye.entityField == 'areaCode'">{{ scope.row.caiProvince }} {{ scope.row.caiCity }} {{ scope.row.caiArea }}</span>
                                                        <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                        </template>
                                    </el-table>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div v-if="dataActionBox.actionType == 4||(dataActionBox.actionType == 1&&actionData.btnType=='审核修改')" style="margin-top:20px;">
                    <el-form :model="taskData" label-width="130px" size="mini" v-if="dataActionBox.actionType == 4||(dataActionBox.actionType == 1&&actionData.btnType=='审核修改')">
                        <el-form-item label="审批结果">
                            <el-radio-group v-model="taskData.auditState">
                                <el-radio-button :label="1">同意</el-radio-button>
                                <el-radio-button :label="0">不同意</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="审批意见" prop="auditRemark" :rules="[{ required: auditRemarkRequired, message: '请输入审批意见', trigger: ['blur', 'change'] }]">
                            <el-input type="textarea" placeholder="请输入内容" v-model="taskData.auditRemark" maxlength="200" show-word-limit>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div class="foot">
                    <div v-if="actionData.btnType=='审核修改'">
                        <span style="color:red;font-size: 18px;margin-right: 10px;" v-if="message">{{ message }}</span>
                        <el-button v-if="$common.checkIsPrint()" type="primary" @click="showPrintPlan">查看</el-button>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')">客户修改审核</el-button>
                    </div>
                    <div v-else>
                        <span style="color:red;font-size: 18px;margin-right: 10px;" v-if="message">{{ message }}</span>
                        <el-button v-if="(dataActionBox.actionType == 2 || dataActionBox.actionType == 4) && $common.checkIsPrint()" type="primary" @click="showPrintPlan">{{ dataActionBox.actionType == 4 ? '查看' : '打印' }}</el-button>
                        <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="printImg(sendDataInfo.cuslicencelinfos)">批量打印</el-button>
                        <el-button type="primary" @click="initActionBox" v-if="dataActionBox.actionType != 2">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0">保存
                        </el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存
                        </el-button>
                        <!-- <el-button type="primary" v-if="dataActionBox.actionType==3" @click="submitData()">提交客户</el-button> -->
                        <el-button type="primary" v-if="dataActionBox.actionType == 4" @click="submitDataAction()">提交客户审核
                        </el-button>
                    </div>
                </div>
            </div>

        </div>

        <!-- 范围穿梭框 -->
        <el-dialog :title="'选择' + rangeTitle" :visible.sync="dialogRange" width="70%" :modal-append-to-body='true' id="csDia" :append-to-body="true" :before-close="handleClose">
            <div class="edit_dev">
                <el-transfer filterable v-if="dialogRange" target-order="push" :filter-method="filterMethod" filter-placeholder="请输入范围名称" v-model="rangeValue" :titles="['未选择', '已选择']" :data="transferData">
                </el-transfer>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="confirmRange">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 检索 -->
        <el-dialog :title="seTitle" v-if="dialogVisible" :visible.sync="dialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog v-if="customFlag" title="客户信息提取" :visible.sync="customFlag" width="80%" height="800" :modal-append-to-body='true' :append-to-body="true" top="30px">
            <ExtractionCustomer ref="SchemeCustom" @TranData="TranData" />
        </el-dialog>
        <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true" :before-close="showClose">
            <el-table :data="dialogList" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showClose">确 定</el-button>
            </span>
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <el-dialog title="批量打印" :visible.sync="diaImgs" width="900px" :modal-append-to-body="true" :append-to-body="true">
            <el-button type="primary" v-print="'#imgs'" size="mini" style="margin-bottom:10px">打印</el-button>
            <div id="imgs" style="width: 800px;">
                <div v-for="(key, index) in fileData" :key="index" style="height: 1100px;width: 800px; position: relative; ">
                    <el-image v-if="key.flag" :style="`width: 1100px;height: 800px;transform: rotateZ(90deg);position: absolute;left:-148px;bottom:148px;`" :src="key.fileUrl" fit="contain"></el-image>
                    <el-image v-else :style="`max-width: 800px;max-height: 1100px;height:100%;`" :src="key.fileUrl" fit="contain"></el-image>
                    <div style="page-break-after: always;"></div>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="证照范围" :visible.sync="cliScopeShow" width="500px" :modal-append-to-body="true" :append-to-body="true">
            <el-input v-if="cliScopeShow" :readonly="cliScopeType==1?true:false" type="textarea" :autosize="{ minRows: 8, maxRows: 10}" placeholder="请输入内容" v-model="sendDataInfo.cuslicencelinfos[cliScopeIndex][entityField]" />
            <span slot="footer" class="dialog-footer" v-if="cliScopeType!=1">
                <el-button type="primary" @click="cliScopeSubmit">保 存</el-button>
            </span>
        </el-dialog>
        <FileNewAction ref="FileNewAction" v-if="showFile" @isshowFile="IsshowFile" :showFile="showFile" @NewelectFileIds="changeInputModelgps"></FileNewAction>
        <DragUpload ref="dragUpload" title="文件上传" :multiple="true" :limit="100" @confirm="onUploadConfirm" />
        <!-- 扫描仪 -->
        <el-dialog title="扫描仪上传" destroy-on-close :visible.sync="scanShow" width="80%" append-to-body top="20px">
            <scannerPlugin v-if="scanShow" ref="scannerPlugin" @submit="scanOnSubmit"></scannerPlugin>
        </el-dialog>
    </div>
</template>

<script>
import print from 'vue-print-nb'
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import ExtractionCustomer from "../byComponents/ExtractionCustomer.vue";
import salesSettingUnitForm from '../components/salesSettingUnitForm.vue';
import customerCertificates from '../components/customerCertificates.vue';
import customerBank from '../components/customerBank.vue';
import { regionData } from 'element-china-area-data'
import axios from 'axios';
export default {
    name: "customerDataAction",

    //import引入的组件需要注入到对象中才能使用
    components: {
        ExtractionCustomer,
        SearchScheme,
        salesSettingUnitForm,
        customerCertificates,
        customerBank,
    },
    props: ["actionData"],
    data() {
        //这里存放数据
        return {
            imgPreviewUrl: [], // 当前要放大的图片存放位置
            addressABC: [],
            auditRemarkRequired: window.global_config.auditRemarkRequired,
            options: regionData,
            parentSearchData: {
                cmId: "",
                opmSalesperson: 1
            },
            reviewNodeList: [], //审核任务
            taskData: {
                //审核数据
                auditState: 1,
                auditRemark: "",
                businessId: "",
            },
            selectedAddressIndex: 0, //地址选择
            selectedBankIndex: 0, //银行卡选择
            selectedFinanceIndex: 0, //财务选择
            selectedlicenceIndex: 0, //证照选择
            showTabs: "",
            formDataList: [],
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                gcmId: "", //gsp首营客户记录id
                cmId: "", //客户id
                cmName: "", //客户名称
                cmIntype: "", //单位类型
                cmHemcode: "", //助记码
                cmLegalperson: "", //法定代表人
                cmRegaddres: "", //注册地址
                cmSocialcode: "", //统一社会信用代码
                cmRegmoney: "", //注册资本
                cmManrange: "", //经营范围
                cmTrerange: "", //诊疗范围
                levleId: 0, //价格策略级别
                fileNumber: "", //档案编号
                cmQualityDirector: "", // 质量负责人
                cfiCreditperiod: "", //信贷期
                cfiCreditamount: "", //信贷额
                cmBank: "", //开户行
                cmBankaccount: "", // 银行账号
                cmRemark: "", //备注
                cmReserves1: "",
                cmReserves2: "",
                cmReserves3: "",
                cmReserves4: "",
                cmReserves5: "",
                cmReserves6: "",
                cuslicencelinfos: [], //证照
                cmState: 1,
                gcmStatus: 1,
                levleName: "一级",
                lityName: "",
                lityId: "",
                lityName: "",
                cmBusterm: new Date().getTime(),
                cmCreater: 0,
                cmFounddate: new Date().getTime(),
                cmInternalcode: "",
                cmIntypeName: "",
                cmTrerangeName: "",
                cmManrangeName: "",
                cmWareaddress: "",
                caiArea: "",
                caiCity: "",
                caiLinker: "",
                caiProvince: "",
                unitNum: "",
                salesDataList: [],
                cmPlace: "",
                opmId: "",
                sendDataInfo:'',
                opmName: ""
            },
            obj: {
                cmManrangeValues: "",// 经营范围已选择范围名称
                cmTrerangeValues: "", // 诊疗分为已选择范围名称
            },
            cmManrangeIds: [], // 经营范围已选择范围Id
            cmTrerangeIds: [], // 诊疗分为已选择范围Id
            cmManrangeList: [], // 经营范围数据
            cmTrerangeList: [], // 诊疗分为数据
            dictionariesDatas: [], //单位类型
            imgUrl: "", //图片显示根路径
            componentType: "", //判断父级
            dialogVisible: false,
            customFlag: false,//提取客户信息
            seTitle: "",
            seId: 0,
            seWidth: "0",
            mxHeight: 0,
            salesType: ["客户", "供应商", "收货", "", "提货"], //业务员类型
            rangeTitle: "",
            dialogRange: false,
            transferData: [], //穿梭框数据
            rangeValue: [],
            rangeNum: 0,
            type: 1,
            tabForm: [],
            mxForm: [],
            footForm: [],
            requesUrl: "",
            imgUrl: "",
            seIndex: 0,
            seType: "",
            sField: "",
            selectSalesIndex: 0,
            tableNum: false,
            dialogList: [],
            showDialog: false,
            showStatus: -1,
            message: "",//提示语
            fileData: [],
            diaImgs: false,
            print: {
                id: 'imgs',
                popTitle: 'erp', // 打印配置页上方的标题
                extraHead: 'erp', // 最上方的头部文字，附加在head标签上的额外标签，使用逗号分割
                preview: true, // 是否启动预览模式，默认是false
                previewTitle: 'erp', // 打印预览的标题
                previewPrintBtnLabel: '预览结束，开始打印', // 打印预览的标题下方的按钮文本，点击可进入打印
                zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
                previewBeforeOpenCallback() { console.log('正在加载预览窗口！'); console.log(that.msg, this) }, // 预览窗口打开之前的callback
                previewOpenCallback() { console.log('已经加载完预览窗口，预览打开了！') }, // 预览窗口打开时的callback
                beforeOpenCallback() { console.log('开始打印之前！') }, // 开始打印之前的callback
                openCallback() { console.log('执行打印了！') }, // 调用打印时的callback
                closeCallback() { console.log('关闭了打印工具！') }, // 关闭打印的callback(无法区分确认or取消)
                clickMounted() { console.log('点击v-print绑定的按钮了！') },
                standard: '',
                extarCss: '',
            },
            dataList: [],
            token: {
                token: sessionStorage.getItem("token"),
            },
            LicensetypeList: [],
            rulesList: [],
            zzList: [],
            fileList: [], //文件
            requesUrl: "",
            imgUrl: '',
            eventIndex: 0,
            showFile: false,
            controlTypeList: [],//控销类型
            salseFormData: [],
            //----------------------------------
            descibCusAddress: {},
            selectAddressIndex: 0,
            //----------------------------------
            entityField: "",
            cliScopeIndex: "",
            cliScopeShow: false,
            cliScopeType: 0,
            cmWareaddress: "",
            addressShow: false,
            //---------扫描仪上传
            scanShow: false,
            printScanShow: false,
            ///-------
            codeClassify: '',//编号分类
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.cmName"() {
            //获取助记码
            if (this.dataActionBox.boxTitle != '编辑客户信息' || this.type != 1) {
                this.sendDataInfo.cmHemcode = this.$common.createPinyinCode(this.sendDataInfo.cmName, this.sendDataInfo.cmHemcode);
            }
            this.type++
            this.productVerify()//客户验证
        },
        "sendDataInfo.levleName"() {
            if (this.sendDataInfo.levleName == "" || this.sendDataInfo.levleName == null || this.sendDataInfo.levleName == undefined) {
                this.sendDataInfo.levleId = ""
            }
        },
        zzList: {
            deep: true,
            handler(nvl, ovl) {
                let arr = [...nvl]
                this.sendDataInfo.cuslicencelinfos = this.sendDataInfo.cuslicencelinfos.filter(item => {
                    if (nvl.includes(item.lityId)) {
                        arr.splice(arr.findIndex(items => items == item.lityId), 1)
                        return true
                    } else {
                        return false
                    }
                })
                this.sendDataInfo.cuslicencelinfos.forEach((item, index) => {
                    item.uploadVoList.map(items => {
                        items.url = this.imgUrl + "/" + items.fileUrl
                        items.name = items.fileName
                        return items
                    })
                })
                this.$nextTick(() => {
                    arr.forEach(item => {
                        this.sendDataInfo.cuslicencelinfos.push({
                            lityId: item,	//证照类型
                            lityName: "",
                            isIntercept: 1,	//是否拦截
                            cmModifier: "",//修改人
                            "cliCreater": 0,
                            "cliRedate": 0,
                            "cliReoffice": "",
                            "cliReserves1": "",
                            "cliReserves2": "",
                            "cliReserves3": "",
                            "cliReserves4": "",
                            "cliReserves5": "",
                            "cliReserves6": "",
                            "cliTername": item,	//证照名称
                            "cliTernumber": "",// 证照号
                            "cliTervalidity": 0,
                            "cmId": 0,
                            cliScope: "/",
                            uploadVoList: [],
                            remark: "", //备注
                        })
                        var index = this.sendDataInfo.cuslicencelinfos.length - 1
                        this.lityChange(item, index)
                    })
                })
            }
        },
        "sendDataInfo.cuslicencelinfos": {
            handler: function (newValue, oldValue) {
                newValue.forEach(item => {
                    if (item.cliRedate && item.cliRedate != 0.5 && item.cliTervalidity && item.cliTervalidity != 0.5 && item.cliTervalidity < item.cliRedate) {
                        this.$message.error("有效期不能小于办证日期")
                        item.cliTervalidity = 0.5
                    }
                })
            },
            deep: true
        }
    },
    directives: {
        print
    },
    //方法集合
    methods: {
        OCRResult(list) {
            if (Array.isArray(list)) {
                list.forEach(item => {
                    if (item.result) {
                        Object.keys(this.sendDataInfo).forEach(key => {
                            if (!this.sendDataInfo[key]) {
                                if (item.result[key]) {
                                    this.sendDataInfo[key] = item.result[key]
                                }
                            }
                        })
                    }
                    if (this.zzList.filter(item1 => item1 == item.name).length == 0) {
                        this.sendDataInfo.cuslicencelinfos.push({
                            lityId: item.name,
                            lityName: "",
                            isIntercept: "1",
                            cmModifier: "",//修改人
                            cliCreater: "",
                            cliRedate: item.result1.cliRedate,
                            cliReoffice: item.result1.cliReoffice,
                            "cliReserves1": "",
                            "cliReserves2": "",
                            "cliReserves3": "",
                            "cliReserves4": "",
                            "cliReserves5": "",
                            "cliReserves6": "",
                            cliTername: item.name, //证照名称
                            cliTernumber: item.result1.cliTernumber,
                            cliTervalidity: item.result1.cliTervalidity,
                            cmId: "",
                            cliScope: "/",
                            uploadVoList: item.uploadVoList, //附件
                            remark: "", //备注
                        })
                        this.zzList.push(item.name)
                    } else {
                        let index = this.zzList.findIndex(item1 => item1 == item.name)
                        this.sendDataInfo.cuslicencelinfos[index].uploadVoList.push(...item.uploadVoList)
                    }
                })
                this.$nextTick(() => {
                    if (list.length > 0) {
                        this.$refs["sendDataInfo"].validate();
                    }
                })
            }
        },
        showUploadDialog(index) {
            this.eventIndex = index
            this.$refs.dragUpload.open();
        },
        onUploadConfirm(files) {
            console.log('上传的文件:', files);
            files.forEach(item => {
                this.sendDataInfo.cuslicencelinfos[this.eventIndex].uploadVoList.push({
                    fileUrl: item.fileUrl,
                    url: this.imgUrl + "/" + item.fileUrl,
                    fileName: item.fileName,
                    fileId: item.fileId,
                    fileType: this.sendDataInfo.cuslicencelinfos[this.eventIndex].lityId,
                })
            })
        },
        getUrl(list) {
            return list.map(val => val.url)
        },
        // 证照范围
        cliScopeClick(type, entityField, index) {
            console.log(type);

            this.cliScopeType = type
            this.entityField = entityField
            this.cliScopeIndex = index
            if (this.sendDataInfo.cuslicencelinfos[this.cliScopeIndex][this.entityField] == '/') {
                this.sendDataInfo.cuslicencelinfos[this.cliScopeIndex][this.entityField] = ""
            }
            if (this.cliScopeType == 1 && this.sendDataInfo.cuslicencelinfos[this.cliScopeIndex][this.entityField] == "") {

            } else {
                this.cliScopeShow = true
            }
        },
        cliScopeSubmit() {
            if (this.sendDataInfo.cuslicencelinfos[this.cliScopeIndex][this.entityField] == "") {
                this.sendDataInfo.cuslicencelinfos[this.cliScopeIndex][this.entityField] = "/"
            }
            this.cliScopeShow = false
        },
        //-----------------------
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'cmIntype') {
                this.dictionariesDatas.forEach(item => {
                    if (item.diValue == val) {
                        str = item.diName
                    }
                })
            } else if (fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        rowClick(row) {
            this.selectAddressIndex = this.sendDataInfo.descibCusAddress.indexOf(row)
        },
        delAddress() {
            this.sendDataInfo.descibCusAddress.splice(this.selectAddressIndex, 1)
        },
        blurClick(type) {
            if (!this.addressShow) {
                return
            }
            if (type == "cmWareaddress" && this.sendDataInfo.cmWareaddress != undefined && this.sendDataInfo.cmWareaddress != "" && this.sendDataInfo.cmWareaddress != null) {
                if (this.sendDataInfo.descibCusAddress.length > 0) {
                    if (this.sendDataInfo.cmWareaddress != undefined && this.sendDataInfo.cmWareaddress != "" && this.sendDataInfo.cmWareaddress != null) {
                        var flag = false
                        this.sendDataInfo.descibCusAddress.forEach(item => {
                            if (item.caiType == 2) {
                                flag = true
                                this.$set(item, 'caiAddress', this.sendDataInfo.cmWareaddress)
                            }
                        })
                        if (!flag) {
                            this.addAddress(false)
                        }
                    }
                    return
                }
                this.addAddress(true)
            }
        },
        addAddress(val) {
            if (this.sendDataInfo.descibCusAddress.length > 0) {
                var arr = this.sendDataInfo.descibCusAddress.filter(val => val.areaCode == "" || val.areaCode == null)
                if (arr.length > 0) {
                    return this.$message.error("请完善已增的省市区，再新增一行")
                }
            }
            this.sendDataInfo.descibCusAddress.push({})
            this.selectAddressIndex = this.sendDataInfo.descibCusAddress.length - 1
            for (const key in this.descibCusAddress) {
                this.$set(this.sendDataInfo.descibCusAddress[this.selectAddressIndex], key, this.descibCusAddress[key])
            }
            this.$set(this.sendDataInfo.descibCusAddress[this.selectAddressIndex], 'cmId', this.sendDataInfo.cmId || "")
            this.$set(this.sendDataInfo.descibCusAddress[this.selectAddressIndex], 'cmName', this.sendDataInfo.cmName || "")
            this.$set(this.sendDataInfo.descibCusAddress[this.selectAddressIndex], 'isDefault', 0)
            this.$set(this.sendDataInfo.descibCusAddress[this.selectAddressIndex], 'caiState', 1)
            if (this.sendDataInfo.areaCode != undefined && this.sendDataInfo.areaCode != "" && this.sendDataInfo.areaCode != null) {
                this.$set(this.sendDataInfo.descibCusAddress[this.selectAddressIndex], 'areaCode', this.sendDataInfo.areaCode)
                this.$set(this.sendDataInfo.descibCusAddress[this.selectAddressIndex], 'caiProvince', this.sendDataInfo.caiProvince)
                this.$set(this.sendDataInfo.descibCusAddress[this.selectAddressIndex], 'caiCity', this.sendDataInfo.caiCity)
                this.$set(this.sendDataInfo.descibCusAddress[this.selectAddressIndex], 'caiArea', this.sendDataInfo.caiArea)
            }
            if (this.sendDataInfo.cmWareaddress != undefined && this.sendDataInfo.cmWareaddress != "" && this.sendDataInfo.cmWareaddress != null && val && this.addressShow) {
                this.$set(this.sendDataInfo.descibCusAddress[this.selectAddressIndex], 'caiAddress', this.sendDataInfo.cmWareaddress)
                this.$set(this.sendDataInfo.descibCusAddress[this.selectAddressIndex], 'caiType', 2)
            } else {
                this.$set(this.sendDataInfo.descibCusAddress[this.selectAddressIndex], 'caiType', 0)
            }
            this.$nextTick(() => {
                if (this.sendDataInfo.descibCusAddress.length == 1) {
                    this.$set(this.sendDataInfo.descibCusAddress[this.selectAddressIndex], 'isDefault', 1)
                }
            })
        },
        delRemove(index, key) {
            this.eventIndex = index
            this.sendDataInfo.cuslicencelinfos[this.eventIndex].uploadVoList.splice(key, 1)
        },
        async fileUpload(files, length, index, e) {
            if (length - 1 >= index) {
                console.log(files[index]);
                const params = {
                    file: files[index]
                }
                const response = await this.$http.uploadFile(params, true)
                console.log(response);
                if (response.status == 200) {
                    this.sendDataInfo.cuslicencelinfos[this.eventIndex].uploadVoList.push({
                        fileUrl: response.result[0].fileUrl,
                        url: this.imgUrl + "/" + response.result[0].fileUrl,
                        fileName: response.result[0].fileName,
                        fileId: response.result[0].fileId,
                        fileType: this.sendDataInfo.cuslicencelinfos[this.eventIndex].lityId,
                    })
                    this.fileUpload(files, length, index + 1, e)
                } else {
                    e.target.value = ""
                    this.$message.error(response.message)
                }
            } else {
                e.target.value = ""
            }
        },
        handlePreview(file) {
            console.log(file);
        },
        changesliTervalidity(index) {

        },
        IsshowFile(value) {
            this.showFile = value
            console.log(this.showFile)
        },
        changeInputModelgps(val) {
            this.sendDataInfo.cuslicencelinfos[this.eventIndex].uploadVoList = [... this.sendDataInfo.cuslicencelinfos[this.eventIndex].uploadVoList, ...val]
            this.showFile = false
        },
        //  打开文件上传组件
        openFile1(val) {
            if (val == 1) {
                this.scanShow = true
            } else {
                this.showFile = true
            }
        },
        // 扫描仪上传
        scanOnSubmit(val) {
            const currentLicence = this.sendDataInfo.cuslicencelinfos[this.eventIndex]
            const fileType = currentLicence.lityId

            // 转换文件数据
            const list = val.map(item => ({
                fileUrl: item.fileUrl,
                url: `${this.imgUrl}/${item.fileUrl}`,
                fileName: item.fileName,
                fileId: item.fileId,
                fileType
            }))

            // 确保 uploadVoList 存在
            if (!currentLicence.uploadVoList) {
                currentLicence.uploadVoList = []
            }

            // 添加新文件
            currentLicence.uploadVoList = [...currentLicence.uploadVoList, ...list]
            this.scanShow = false
        },
        changesmIntype() {
            this.LicensetypeList.forEach(item => {
                this.$set(item, "isBT", 0)
                this.$set(item, "isKX", 0)
            })
            this.rulesList.forEach(item => {
                if (item['单位类型'] == this.sendDataInfo.cmIntype) {
                    item['拦截证照'].forEach(items => {
                        var arr = items['证照名称'].split(",")
                        if (arr.length == 1) {
                            var flag = false
                            var flage = false
                            if (this.zzList.length > 0) {
                                this.zzList.forEach(item => {
                                    if (item == arr[0]) {
                                        flage = true
                                    }
                                })
                            }
                            if (!flage) {
                                this.zzList.push(arr[0])
                            }
                            this.LicensetypeList.forEach(item => {
                                if (item.diName == arr[0]) {
                                    this.$set(item, "isBT", 1)
                                }
                            })
                            if (this.sendDataInfo.cuslicencelinfos.length > 0) {
                                this.sendDataInfo.cuslicencelinfos.forEach(item => {
                                    if (item.lityId == arr[0]) {
                                        flag = true
                                    }
                                })
                            }
                            if (!flag) {
                                this.sendDataInfo.cuslicencelinfos.push({
                                    lityId: arr[0],	//证照类型
                                    lityName: "",
                                    isIntercept: 1,	//是否拦截
                                    cmModifier: "",//修改人
                                    "cliCreater": 0,
                                    "cliRedate": 0,
                                    "cliReoffice": "",
                                    "cliReserves1": "",
                                    "cliReserves2": "",
                                    "cliReserves3": "",
                                    "cliReserves4": "",
                                    "cliReserves5": "",
                                    "cliReserves6": "",
                                    "cliTername": arr[0],	//证照名称
                                    "cliTernumber": "",// 证照号
                                    "cliTervalidity": 0,
                                    "cmId": 0,
                                    cliScope: "/",
                                    uploadVoList: [],
                                    remark: "", //备注
                                })
                                var index = this.sendDataInfo.cuslicencelinfos.length - 1
                                this.lityChange(arr[0], index)
                            }
                        } else {
                            this.LicensetypeList.forEach(item => {
                                arr.forEach(item1 => {
                                    if (item1 == item.diName) {
                                        this.$set(item, "isKX", 1)
                                    }
                                })
                            })

                        }
                    })
                }
            })
        },
        seeTypeChange() {
            this.LicensetypeList.forEach(item => {
                this.$set(item, "isBT", 0)
                this.$set(item, "isKX", 0)
            })
            this.rulesList.forEach(item => {
                if (item['单位类型'] == this.sendDataInfo.cmIntype) {
                    item['拦截证照'].forEach(items => {
                        var arr = items['证照名称'].split(",")
                        if (arr.length == 1) {
                            this.LicensetypeList.forEach(item => {
                                if (item.diName == arr[0]) {
                                    this.$set(item, "isBT", 1)
                                }
                            })
                        } else {
                            this.LicensetypeList.forEach(item => {
                                arr.forEach(item1 => {
                                    if (item1 == item.diName) {
                                        this.$set(item, "isKX", 1)
                                    }
                                })
                            })

                        }
                    })
                }
            })
        },
        lityChange(data, index) {
            if (/(营业)/g.test(data)) {
                this.sendDataInfo.cuslicencelinfos[index].cliTernumber = this.sendDataInfo.cmSocialcode

            } else {
                this.sendDataInfo.cuslicencelinfos[index].cliTernumber = ''
            }
            this.sendDataInfo.cuslicencelinfos[index].lityId = data;
        },
        blurChange(type) {
            if (type == 'cmSocialcode') {
                this.sendDataInfo.cuslicencelinfos.forEach((item, index) => {
                    if (item.cliTernumber == "" || item.cliTernumber == null) {
                        this.lityChange(item.lityId, index)
                    }
                })
            }
        },
        async setzzList() {
            const res = await this.$http.getCusLicenceRule()
            this.rulesList = JSON.parse(res.result)
            if (this.sendDataInfo.cmIntype) {
                this.seeTypeChange()
            }
        },
        imgur() {
            // console.log(this.$store.getters.getConfig);
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        judge(val) {
            if (this.diaImgs) {
                this.$nextTick(() => {
                    console.log(val, document.documentElement.querySelector(`.${val}`));
                })
            }
            // console.log(document.documentElement.querySelector(`.${val}`).querySelector('el-image__inner').clientHeight,
            // document.documentElement.querySelector(`.${val}`).querySelector('el-image__inner').clientWidth,);
            return true
        },
        confirmPrintImgs() {
            this.$print(document.getElementById('imgs'))
        },
        printImgs() {
            this.diaImgs = true
        },
        print() {
            this.$print(document.getElementById('prr'))
        },
        printImg(list) {
            let printArr = []
            list.forEach(item => {
                item.uploadVoList.forEach(e => {
                    if (e.fileUrl != '' && e.fileUrl) {
                        printArr.push(window.global_config.BASE_IMG_URL + '/' + e.fileUrl)
                    }
                })
            })

            this.fileData = []
            printArr.forEach(url => {
                let item = {
                    flag: "",
                    fileUrl: url
                }
                const img = new Image();
                img.src = url
                img.onload = () => {
                    console.log(img.src);
                    console.log(img.width);
                    console.log(img.height);
                    if (img.width > img.height) {
                        item.flag = true
                    } else {
                        item.flag = false
                    }
                    this.fileData.push(item)
                };

            })

            this.diaImgs = true
            // this.$common.batchPrintImage(printArr)
        },
        //客户验证
        productVerify() {
            var cmName = this.sendDataInfo.cmName.replace(/\s/g, "")
            if (cmName != "") {
                this.verify()
            }
        },
        async verify() {
            const params = {
                "cmId": 0,
                "cmName": ""
            }
            for (const key in params) {
                if (this.sendDataInfo[key]) {
                    params[key] = this.sendDataInfo[key]
                } else {
                    params[key] = ""
                }
            }
            const responseData = await this.$http.gspCustomercheckRepeatCus(params)
            if (responseData.status == 300) {
                this.message = responseData.message
            } else {
                this.message = ""
            }
        },
        handleDetailsChange(value, index) {
            this.selectAddressIndex = index
            setTimeout(() => {
                var node = this.$refs['cascader1'][index].getCheckedNodes()[0]
                if (!node) {
                    this.sendDataInfo.descibCusAddress[index].caiProvince = ""
                    this.sendDataInfo.descibCusAddress[index].caiCity = ""
                    this.sendDataInfo.descibCusAddress[index].caiArea = ""
                } else {
                    if (node.pathLabels.length == 3) {
                        this.sendDataInfo.descibCusAddress[index].caiProvince = node.pathLabels[0]
                        this.sendDataInfo.descibCusAddress[index].caiCity = node.pathLabels[1]
                        this.sendDataInfo.descibCusAddress[index].caiArea = node.pathLabels[2]
                    } else if (node.pathLabels.length == 2) {
                        this.sendDataInfo.descibCusAddress[index].caiProvince = node.pathLabels[0]
                        this.sendDataInfo.descibCusAddress[index].caiCity = node.pathLabels[1]
                    }
                }
            }, 100)
        },
        handleAddChange(value, setField) {
            setTimeout(() => {
                var node = this.$refs['cascader'][0].getCheckedNodes()[0]
                if (!node) {
                    this.sendDataInfo.caiProvince = ""
                    this.sendDataInfo.caiCity = ""
                    this.sendDataInfo.caiArea = ""
                    if (setField) {
                        var arr = setField.split(',')
                        arr.forEach(item => {
                            this.sendDataInfo[item] = ""
                        })
                    }
                    return
                }
                if (node.pathLabels.length == 3) {
                    this.sendDataInfo.caiProvince = node.pathLabels[0]
                    this.sendDataInfo.caiCity = node.pathLabels[1]
                    this.sendDataInfo.caiArea = node.pathLabels[2]
                    if (setField) {
                        var arr = setField.split(',')
                        arr.forEach(item => {
                            this.sendDataInfo[item] = `${this.sendDataInfo.caiProvince}${this.sendDataInfo.caiCity}${this.sendDataInfo.caiArea}`
                        })
                    }
                } else if (node.pathLabels.length == 2) {
                    this.sendDataInfo.caiProvince = node.pathLabels[0]
                    this.sendDataInfo.caiCity = node.pathLabels[1]
                    if (setField) {
                        var arr = setField.split(',')
                        arr.forEach(item => {
                            this.sendDataInfo[item] = `${this.sendDataInfo.caiProvince}${this.sendDataInfo.caiCity}`
                        })
                    }
                }

            }, 100)
        },

        tableRowClassName({
            row,
            rowIndex
        }) {
            return 'success-row';
        },
        pushData(e, i) {
            if (i == 0) {
                this.sendDataInfo.salesDataList.push(JSON.parse(JSON.stringify(e)))
            } else {
                this.sendDataInfo.salesDataList[this.selectSalesIndex] = JSON.parse(JSON.stringify(e))
            }
            this.tableNum = this.tableNum ? false : true
        },
        delLicense() {
            if (this.sendDataInfo.salesDataList.length == 0) {
                this.$message.error("暂无可删除数据")
                return
            }
            this.sendDataInfo.salesDataList.splice(this.selectSalesIndex, 1)
            this.$nextTick(() => {
                this.selectSalesIndex = 0
            })
        },
        //新增委托
        addLicense() {
            this.$refs["salesSettingUnitForm"].openBox(0, '', 1, this.salseFormData);
        },
        //编辑委托
        updateLicense() {
            this.$refs["salesSettingUnitForm"].openBox(1, this.sendDataInfo.salesDataList[this.selectSalesIndex], 1, this.salseFormData);
        },

        TranData(val) {
            this.sendDataInfo.descibCusAddress = []
            for (const key in this.sendDataInfo) {
                this.rangeValue = []
                if (key == "cmManrange") {
                    this.cmManrangeIds = this.isNullOrUd(val[key]) ? [] : val[key].split(",");
                    this.cmManrangeIds = this.cmManrangeIds.map(Number);
                    this.cmManrangeList.forEach((item, index) => {
                        this.cmManrangeIds.forEach(item1 => {
                            if (item.discId == item1) {
                                this.rangeValue.push(item.scopeName)
                                this.obj.cmManrangeValues = this.rangeValue.toString();
                            }
                        })
                    })
                } else if (key == "cmTrerange") {
                    this.cmTrerangeIds = this.isNullOrUd(val[key]) ? [] : val[key].split(",");
                    this.cmTrerangeIds = this.cmTrerangeIds.map(Number);
                    this.cmTrerangeList.forEach((item, index) => {
                        this.cmTrerangeIds.forEach(item1 => {
                            if (item.discId == item1) {
                                this.rangeValue.push(item.scopeName)
                                this.obj.cmTrerangeValues = this.rangeValue.toString();
                            }
                        })
                    })

                } else {
                    if (val[key] != undefined && val[key] != "" && val[key] != null) {
                        this.sendDataInfo[key] = val[key]
                    }
                }
            }
            if (this.sendDataInfo.caiArea != "") {
                for (const element of regionData) {
                    if (this.sendDataInfo.caiProvince == element.label) {
                        for (const element1 of element.children) {
                            if (this.sendDataInfo.caiCity == element1.label) {
                                for (const element2 of element1.children) {
                                    if (this.sendDataInfo.caiArea == element2.label) {
                                        this.$set(this.sendDataInfo, 'areaCode', element2.value)
                                    }
                                }
                            }
                        }
                    }

                }
            } else if (this.sendDataInfo.caiCity != "") {
                for (const element of regionData) {
                    if (this.sendDataInfo.caiProvince == element.label) {
                        for (const element1 of element.children) {
                            if (this.sendDataInfo.caiCity == element1.label) {
                                this.$set(this.sendDataInfo, 'areaCode', element1.value)
                            }
                        }
                    }
                }
            }
            if (this.sendDataInfo.descibCusAddress != undefined && this.sendDataInfo.descibCusAddress != null && this.sendDataInfo.descibCusAddress.length > 0) {
                this.sendDataInfo.descibCusAddress.forEach(item => {
                    if (item.areaCode != undefined && item.areaCode != null && item.areaCode != "") {
                    } else if (item.caiArea != undefined && item.caiArea != "") {
                        for (const element of regionData) {
                            if (this.sendDataInfo.caiProvince == element.label) {
                                for (const element1 of element.children) {
                                    if (this.sendDataInfo.caiCity == element1.label) {
                                        for (const element2 of element1.children) {
                                            if (this.sendDataInfo.caiArea == element2.label) {
                                                this.$set(this.item, 'areaCode', element2.value)
                                            }
                                        }
                                    }
                                }
                            }

                        }
                    } else if (item.caiCity != undefined && item.caiCity != "") {
                        for (const element of regionData) {
                            if (this.sendDataInfo.caiProvince == element.label) {
                                for (const element1 of element.children) {
                                    if (this.sendDataInfo.caiCity == element1.label) {
                                        this.$set(this.item, 'areaCode', element1.value)
                                    }
                                }
                            }
                        }
                    } else if (item.caiProvince != undefined && item.caiProvince != "") {
                        for (const element of regionData) {
                            if (this.sendDataInfo.caiProvince == element.label) {
                                this.$set(this.item, 'areaCode', element.value)
                            }
                        }
                    }
                })
            }
            if (this.sendDataInfo.cuslicencelinfos) {
                this.zzList = this.sendDataInfo.cuslicencelinfos.map(item => item.lityId)
                if (this.sendDataInfo.cuslicencelinfos.length > 0) {
                    this.sendDataInfo.cuslicencelinfos.forEach(item => {
                        if (item.cliScope == undefined || item.cliScope == "" || item.cliScope == null) {
                            item.cliScope = "/"
                        }
                    })
                }
            }
            if (this.sendDataInfo.cmWareaddress != undefined && this.sendDataInfo.cmWareaddress != "" && this.sendDataInfo.cmWareaddress != null && this.addressShow) {
                this.addAddress(true)
            }
            this.customFlag = false
        },
        extractCustom() {
            this.customFlag = true
            this.$nextTick(() => {
                this.$refs["SchemeCustom"].openBox(this.tabForm);
            })
        },
        // 下拉赋值
        handleChange(value, name) {
            // value默认参，name当前所需的name
            this.sendDataInfo[name] = value;
        },
        //业务员图片转换
        pictureFilePath(data) {
            var pathList = data.split(",");
            var imgList = [];
            pathList.forEach((v) => {
                imgList.push(this.imgUrl + "/" + v);
            });
            return imgList;
        },
        // 选择范围确定
        confirmRange() {
            if (this.rangeNum == 1) {
                this.cmManrangeIds = this.rangeValue; //经营范围
                var value1 = [];
                this.cmManrangeIds.forEach(val => {
                    if (this.cmManrangeList) {
                        if (this.cmManrangeList.filter(item => val == item.discId).length > 0) {
                            value1.push(this.cmManrangeList.filter(item => val == item.discId)[0].scopeName);
                        }

                    }
                })

                this.obj.cmManrangeValues = value1.toString();
            } else if (this.rangeNum == 2) {
                this.cmTrerangeIds = this.rangeValue; //诊疗范围
                var value2 = [];
                this.cmTrerangeIds.forEach(val => {
                    if (this.cmTrerangeList.length > 0) {
                        if (this.cmTrerangeList.filter(item => val == item.discId).length > 0) {
                            value2.push(this.cmTrerangeList.filter(item => val == item.discId)[0].scopeName)
                        }
                    }
                })
                this.obj.cmTrerangeValues = value2.toString();
            }
            this.dialogRange = false;
        },
        // 过滤方法
        filterMethod(query, item) {
            console.log(item);
            if (query != '') {
                if (/^[a-zA-Z]*$/.test(query)) {
                    // alert("“" + str + "”里全是字母！");
                    return item.pinyin.indexOf(query) > -1;
                }
                else if (/^[\u4e00-\u9fa5]*$/.test(query)) {
                    // alert("“" + str + "”里全是汉字！");
                    return item.label.indexOf(query) > -1;
                }
            }
            return item.pinyin.indexOf(query) > -1;
        },
        // 打开选择范围
        openRange(title, type) {
            this.rangeValue = [];
            this.transferData = [];
            this.rangeTitle = title;
            if (type == "cmManrange") {
                this.rangeNum = 1;
                if (this.cmManrangeIds.length > 0) {
                    this.rangeValue = this.cmManrangeIds.map(Number);
                }
                this.cmManrangeList.forEach((item) => {
                    this.transferData.push({
                        label: item.scopeName,
                        key: item.discId,
                        pinyin: item.scopeCode,
                    });
                });
            } else if (type == "cmTrerange") {
                this.rangeNum = 2;
                if (this.cmTrerangeIds.length > 0) {
                    this.rangeValue = this.cmTrerangeIds.map(Number);
                }
                this.cmTrerangeList.forEach((item) => {
                    this.transferData.push({
                        label: item.scopeName,
                        key: item.discId,
                        pinyin: item.scopeCode,
                    });
                });
            }
            this.dialogRange = true;
        },
        // 是否确认关闭
        handleClose(done) {
            this.$confirm("关闭弹窗将删除已选择的范围，确认关闭？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.dialogRange = false;
                })
                .catch(() => { });
        },
        //设置默认地址
        setDefaultAddress() {
            this.sendDataInfo.cusaddresses.forEach((v) => (v.isDefault = 0));
            this.sendDataInfo.cusaddresses[
                this.selectedAddressIndex
            ].isDefault = 1;
        },
        async showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                if (this.dataActionBox.actionType == 4 || this.actionData.btnType == '审核修改') {
                    let responseData = await this.$http.getPenetrateData({ ids: [this.actionData.orderId] })
                    console.log(responseData);
                    if (responseData.status == 200) {
                        var res = responseData.result
                        // 选中的数据
                        this.$refs.printPlan.openDia(
                            this.actionData.orderId,
                            res.printSource,
                            res.jurId,
                            'oper'
                        );
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: 'error'
                        });
                    }
                } else {
                    // 选中的数据
                    this.$refs.printPlan.openDia(
                        this.actionData.orderId,
                        this.actionData.printSouce,
                        this.actionData.printJurId
                    );
                }
            } else {
                return;
            }
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },
        //图片地址转换
        pictureShow(data) {
            var imgList = [];
            data.forEach((item) => {
                imgList.push(this.imgUrl + "/" + item.fileUrl);
            });
            return imgList;
        },
        //检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.dialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.parentSearchData[type] = this.sendDataInfo[type];
            console.log(this.seType);
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = val[item];
            });
        },
        changeInputModel(val) {
            console.log("返回", val);
            console.log("返回", this.seType);
            if (val != "" || val != undefined) {
                this.dialogVisible = false;
                if (this.seType == "cmName") {
                    for (const key in val) {
                        this.rangeValue = []
                        if (key == "cmManrange") {
                            this.cmManrangeIds = this.isNullOrUd(val[key]) ? [] : val[key].split(",");
                            this.cmManrangeIds = this.cmManrangeIds.map(Number);
                            this.cmManrangeList.forEach((item, index) => {
                                this.cmManrangeIds.forEach(item1 => {
                                    if (item.discId == item1) {
                                        this.rangeValue.push(item.scopeName)
                                        this.obj.cmManrangeValues = this.rangeValue.toString();
                                    }
                                })
                            })
                        } else if (key == "cmTrerange") {
                            this.cmTrerangeIds = this.isNullOrUd(val[key]) ? [] : val[key].split(",");
                            this.cmTrerangeIds = this.cmTrerangeIds.map(Number);
                            this.cmTrerangeList.forEach((item, index) => {
                                this.cmTrerangeIds.forEach(item1 => {
                                    if (item.discId == item1) {
                                        this.rangeValue.push(item.scopeName)
                                        this.obj.cmTrerangeValues = this.rangeValue.toString();
                                    }
                                })
                            })

                        } else if (key != 'cmId') {
                            this.sendDataInfo[key] = val[key];
                        }
                    }
                } else {
                    this.paramValue(val);
                }
                if (this.sendDataInfo.cmIntype) {
                    this.seeTypeChange()
                }
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        //判断为null或者空值时给初始值
        isNullOrUd(num) {
            if (typeof num === 'object' || isNaN(parseFloat(num))) {
                return true
            } else {
                return false
            }
        },
        //换行提示
        lineMessageBox(data) {
            let txtArr = data.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
                newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), "提示", {
                confirmButtonText: "确定",
                callback: (action) => { },
            });
        },

        // 新增或修改
        async sendDataAction() {
            this.$refs["sendDataInfo"].validate((valid) => {
                if (valid) {
                    this.$refs["sendDataInfo1"].validate(async (valids) => {
                        if (valids) {
                            this.sendDataInfo.cuslicencelinfos.forEach(item => {
                                if (item.cliTervalidity == 0) {
                                    item.cliTervalidity = ""
                                }
                                if (item.cliRedate == 0) {
                                    item.cliRedate = ""
                                }
                            })
                            if (this.sendDataInfo.descibCusAddress.length == 0) {
                                return this.$message.error("请维护收货地址")
                            }
                            let interceptData = {
                                formId: this.formDataList[1].jciId,
                                cuslicencelinfos: this.sendDataInfo.cuslicencelinfos,
                                cmIntype: this.sendDataInfo.cmIntype,
                                unitId:this.sendDataInfo.cmId,
                                salesDataList: this.sendDataInfo.salesDataList,
                            };
                            let addIntercept = await this.$http.checkVendorCustomer(interceptData);
                            if (addIntercept.status == 200) {
                                if (addIntercept.result.length > 0) {
                                    this.dialogList = addIntercept.result
                                    this.showStatus = this.dialogList.findIndex(item => item.level == 0)
                                    this.showDialog = true
                                } else {
                                    this.sub()
                                }
                            } else {
                                this.$message.error(addIntercept.message)
                            }
                        } else {
                            this.$message({
                                message: "请完善必填信息",
                                type: "error",
                            });
                            return false;
                        }
                    });
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                    return false;
                }
            });
        },
        showClose() {
            this.showDialog = false
            if (this.showStatus == -1) {
                this.sub()
            }
        },
        dealMinWidth(field) {
            if (field == 'cliTername' || field == 'lityId' || field == 'cliReoffice' || field == 'cliTernumber' || field == 'cliRedate' || field == 'cliTervalidity') {
                return '200'
            } else if (field == 'uploadVoList') {
                return '230'
            } else {
                return '100'
            }
        },
        async sub() {
            this.sendDataInfo.cmManrange = this.cmManrangeIds.toString();
            this.sendDataInfo.cmTrerange = this.cmTrerangeIds.toString();
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (sendData.areaCode == null || sendData.areaCode == "") {
                sendData.caiProvince = ""
                sendData.caiCity = ""
                sendData.caiArea = ""
            }
            let responseData;
            if (this.componentType == "GSP") {
                if (sendData.salesDataList.length > 0) {
                    sendData.salesDataList.forEach(item => {
                        if (item.terType == 1) {
                            item.bgmIds = []
                            if (item.descibSalesplicencedetailVo != null && item.descibSalesplicencedetailVo.length > 0) {
                                item.descibSalesplicencedetailVo.forEach(item1 => {
                                    item.bgmIds.push(item1.bgmId)
                                })
                            }
                        }
                    })
                }
            }
            if (this.actionData.btnType == '审核修改') {
                let params = {
                    auditAddDto: this.taskData,
                    update: sendData
                }
                responseData = await this.$http.gspCustomerauditModify(params)
                if (responseData.status == 200) {
                    this.init();
                    this.$message({
                        message: "操作成功",
                        type: "success",
                    });
                    this.$emit("drawerCancel", true);
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            } else {
                if (this.dataActionBox.actionType == 0) {
                    if (this.componentType == "GSP") {
                        responseData = await this.$http.addFirstCustomer(sendData);
                    } else {
                        responseData = await this.$http.addCusmaster(sendData);
                    }
                } else if (this.dataActionBox.actionType == 1) {
                    if (this.componentType == "GSP") {
                        responseData = await this.$http.setFirstCustomer(sendData);
                    } else {
                        responseData = await this.$http.setCusmaster(sendData);
                    }
                } else {
                    //审核
                }
                if (responseData.status == 200) {
                    this.$emit("drawerCancel", true);
                    this.$refs["sendDataInfo"].resetFields();
                    this.init();
                    this.$message({
                        message: "操作成功",
                        type: "success",
                    });
                } else if (responseData.status == 300) {
                    this.$confirm(responseData.message + ", 是否继续新增?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(async () => {
                            this.sendDataInfo.state = 0;
                            this.sub();
                        })
                        .catch(() => {
                            this.sendDataInfo.state = "";
                        });
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            }
        },
        // 提交审核
        submitDataAction() {
            if (this.auditRemarkRequired && !this.taskData.auditRemark) {
                this.$message({
                    message: "请输入审批意见",
                    type: "warning",
                });
                return;
            }
            this.$confirm("确定要提交审核?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let responseData = await this.$http.addTaskReview(this.taskData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功",
                        });
                        this.$emit("drawerCancel", true);
                        this.$parent.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },
        // 编辑银行卡信息
        editBank(pageData, sid) {
            if (this.sendDataInfo.cusbankinfos.length < 1) {
                this.$message({
                    message: "请先添加银行卡信息",
                    type: "error",
                });
                return false;
            }
            this.$refs["customerBank"].openBox(
                1,
                pageData,
                sid,
                JSON.parse(
                    JSON.stringify(
                        this.sendDataInfo.cusbankinfos[this.selectedBankIndex]
                    )
                )
            );
        },
        //银行卡子组件修改的数据
        returnBank(data, typ) {
            if (typ == 0) {
                this.sendDataInfo.cusbankinfos.unshift(data);
            } else {
                this.sendDataInfo.cusbankinfos.splice(
                    this.selectedBankIndex,
                    1,
                    data
                );
            }
            this.selectedBankIndex = 0;
        },
        // 删除银行卡
        delcustomerBank() {
            if (this.sendDataInfo.cusbankinfos.length < 1) {
                this.$message({
                    message: "当前没有银行卡信息",
                    type: "error",
                });
                return false;
            }
            this.$confirm("确定删除该数据?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.sendDataInfo.cusbankinfos.splice(this.selectedBankIndex, 1);
                    this.selectedBankIndex = 0;
                })
                .catch(() => { });
        },
        // 编辑证照信息
        editCertofocates(pageData, sid) {
            if (this.sendDataInfo.cuslicencelinfos.length < 1) {
                this.$message({
                    message: "请先添加证照信息",
                    type: "error",
                });
                return false;
            }
            this.$refs["customerCertificates"].openBox(
                1,
                pageData,
                sid,
                JSON.parse(
                    JSON.stringify(
                        this.sendDataInfo.cuslicencelinfos[this.selectedlicenceIndex]
                    )
                )
            );
        },
        //证照子组件修改的数据
        returnlicence(data, typ) {
            console.log(data);
            if (typ == 0) {
                this.sendDataInfo.cuslicencelinfos.unshift(data);
            } else {
                this.sendDataInfo.cuslicencelinfos.splice(
                    this.selectedlicenceIndex,
                    1,
                    data
                );
            }
            this.selectedlicenceIndex = 0;
        },
        //复制一行
        copyClick(row) {
            this.sendDataInfo.cuslicencelinfos.push(JSON.parse(JSON.stringify(row)))
        },
        // 删除证照
        delCertofocates(row) {
            this.selectedlicenceIndex = this.sendDataInfo.cuslicencelinfos.indexOf(row)
            if (this.sendDataInfo.cuslicencelinfos.length < 1) {
                this.$message({
                    message: "当前没有证照信息",
                    type: "error",
                });
                return false;
            }
            this.$confirm("确定删除该数据?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.sendDataInfo.cuslicencelinfos.splice(
                        this.selectedlicenceIndex,
                        1
                    );
                    this.selectedlicenceIndex = 0;
                    this.zzList = this.sendDataInfo.cuslicencelinfos.map(item => {
                        return item.lityId
                    })
                })
                .catch(() => { });
        },
        isShowData(name, value) {
            this.sendDataInfo[name] = value;
        },
        //取消新增
        initActionBox() {
            // if (this.dataActionBox.actionType != 0 || this.dataActionBox.actionType != 1) return this.$emit(
            // 	"drawerCancel");
            if (this.dataActionBox.actionType != 5) {
                this.$confirm(
                    "确定取消" + this.dataActionBox.boxTitle + "吗?",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }
                )
                    .then(() => {
                        this.$emit("drawerCancel");
                        this.init();
                        this.$refs["sendDataInfo"].resetFields();
                    })
                    .catch(() => { });
            } else {
                this.$emit("drawerCancel");
            }
        },
        //初始化
        init() {
            for (const key in this.sendDataInfo) {
                if (
                    key == "cusaddresses" ||
                    key == "cusbankinfos" ||
                    key == "cuslicencelinfos" || key == 'salesDataList'
                ) {
                    this.sendDataInfo[key] = [];
                } else if (key == "cusfinancelinfos") {
                    for (const item in this.sendDataInfo[key]) {
                        this.sendDataInfo[key][item] = "";
                    }
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
            this.dataActionBox.boxTitle = "";
        },
        isNull(value) {
            if (value != undefined && value != "" && value != 0) {
                return true;
            } else {
                return false;
            }
        },
        //父级传入
        openBox() {
            this.getQueryCodeClassifyaArr()
            this.printScanShow = window.global_config.printScanShow ? true : false
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            if (this.dataActionBox.actionType == 2) {
                this.componentType = "GSP"; //父级类型
            } else {
                this.componentType = this.actionData.type;
            }
            this.filterMainField();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增客户信息";
                this.dataActionBox.openMode = "ltr";
                // 如果有 oldData，填充已有数据（复制新增场景）
                if (oldData && Object.keys(oldData).length > 0) {
                    var dataInfo = JSON.parse(JSON.stringify(oldData));
                    for (let key in dataInfo) {
                        this.$set(this.sendDataInfo, key, dataInfo[key])
                    }
                }
            } else if (this.dataActionBox.actionType == 2) {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
                this.cmManrangeIds =
                    this.sendDataInfo.cmManrange &&
                        this.isNull(this.sendDataInfo.cmManrange)
                        ? this.sendDataInfo.cmManrange.split(",")
                        : [];
                this.cmTrerangeIds =
                    this.sendDataInfo.cmTrerange &&
                        this.isNull(this.sendDataInfo.cmTrerange)
                        ? this.sendDataInfo.cmTrerange.split(",")
                        : [];
            } else {
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
                if (this.dataActionBox.actionType == 1) {
                    this.dataActionBox.boxTitle = "编辑客户信息";
                    this.dataActionBox.openMode = "rtl";
                    this.cmManrangeIds =
                        this.sendDataInfo.cmManrange &&
                            this.isNull(this.sendDataInfo.cmManrange)
                            ? this.sendDataInfo.cmManrange.split(",")
                            : [];
                    this.cmTrerangeIds =
                        this.sendDataInfo.cmTrerange &&
                            this.isNull(this.sendDataInfo.cmTrerange)
                            ? this.sendDataInfo.cmTrerange.split(",")
                            : [];
                    if (this.actionData.btnType == '审核修改') {
                        this.getTaskReviewHistory(oldData.gcmId); //审核任务
                        this.taskData.businessId = [oldData.gcmId];
                    }
                } else {
                    this.dataActionBox.boxTitle = "客户信息审核";
                    this.getTaskReviewHistory(oldData.gcmId); //审核任务
                    this.taskData.businessId = [oldData.gcmId];
                    this.cmManrangeIds =
                        this.sendDataInfo.cmManrange &&
                            this.isNull(this.sendDataInfo.cmManrange)
                            ? this.sendDataInfo.cmManrange.split(",")
                            : [];
                    this.cmTrerangeIds =
                        this.sendDataInfo.cmTrerange &&
                            this.isNull(this.sendDataInfo.cmTrerange)
                            ? this.sendDataInfo.cmTrerange.split(",")
                            : [];
                }
            }
            if (this.sendDataInfo.descibCusAddress != undefined && this.sendDataInfo.descibCusAddress != null && this.sendDataInfo.descibCusAddress.length > 0) {
                this.sendDataInfo.descibCusAddress.forEach(item => {
                    if (item.areaCode != undefined && item.areaCode != null && item.areaCode != "") {
                    } else if (item.caiArea != undefined && item.caiArea != "") {
                        for (const element of regionData) {
                            if (this.sendDataInfo.caiProvince == element.label) {
                                for (const element1 of element.children) {
                                    if (this.sendDataInfo.caiCity == element1.label) {
                                        for (const element2 of element1.children) {
                                            if (this.sendDataInfo.caiArea == element2.label) {
                                                this.$set(item, 'areaCode', element2.value)
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    } else if (item.caiCity != undefined && item.caiCity != "") {
                        for (const element of regionData) {
                            if (this.sendDataInfo.caiProvince == element.label) {
                                for (const element1 of element.children) {
                                    if (this.sendDataInfo.caiCity == element1.label) {
                                        this.$set(item, 'areaCode', element1.value)
                                    }
                                }
                            }
                        }
                    } else if (item.caiProvince != undefined && item.caiProvince != "") {
                        for (const element of regionData) {
                            if (this.sendDataInfo.caiProvince == element.label) {
                                this.$set(item, 'areaCode', element.value)
                            }
                        }
                    }
                })
            }
            if (this.sendDataInfo.cuslicencelinfos) {
                this.zzList = this.sendDataInfo.cuslicencelinfos.map(item => item.lityId)
                if (this.sendDataInfo.cuslicencelinfos.length > 0) {
                    this.sendDataInfo.cuslicencelinfos.forEach(item => {
                        if (item.cliScope == undefined || item.cliScope == "" || item.cliScope == null) {
                            item.cliScope = "/"
                        }
                    })
                }
            }
            this.getPartDictionariesData();
            this.gspCustomerAddressFromRule()
            this.setzzList()
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                    this.OCRResult(this.actionData.ocrResults || [])
                }, 16.7)
            });
        },
        async gspCustomerAddressFromRule() {
            const res = await this.$http.gspCustomerAddressFromRule()
            if (res.status == 200) {
                console.log(res.result);
                this.addressShow = res.result == '1' ? true : false

            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                });
            }
        },
        //获取单位类型
        async getCateDictionariesDatas() {
            let responseData = await this.$http.getCateDictionariesData({
                ids: [38],
            });
            if (responseData.status == 200) {
                this.dictionariesDatas = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //获取控销类型
        async getcontrolType() {
            let responseData = await this.$http.getCateDictionariesData({
                ids: [64],
            });
            if (responseData.status == 200) {
                this.controlTypeList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取任务审核历史
        async getTaskReviewHistory(id) {
            let responseData = await this.$http.getTaskReviewHistory({
                ids: [id],
            });
            if (responseData.status == 200) {
                this.reviewNodeList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //获取生产/经营范围
        async getQueryScopeByType(type) {
            let ormId = sessionStorage.getItem("ormId");
            let params = {
                type: type,
                ormId: ormId,
            };
            console.log(this.cmManrangeIds);
            //type 范围类型0.生产范围1.经营范围
            let responseData = await this.$http.queryScopeByType(params);
            if (responseData.status == 200) {
                if (type == 1) {
                    this.cmManrangeList = responseData.result;
                    if (this.dataActionBox.actionType != 0) {
                        var value1 = [];
                        if (this.cmManrangeIds && this.cmManrangeIds.length) {
                            this.cmManrangeIds.forEach(val => {
                                if (this.cmManrangeList.length > 0) {
                                    if (this.cmManrangeList.filter(item => val == item.discId).length > 0) {
                                        value1.push(this.cmManrangeList.filter(item => val == item.discId)[0].scopeName)
                                    }

                                }
                            })
                        }
                        this.obj.cmManrangeValues = value1.toString();
                    }
                } else if (type == 2) {
                    this.cmTrerangeList = responseData.result;
                    if (this.dataActionBox.actionType != 0) {
                        var value2 = [];
                        if (this.cmTrerangeIds && this.cmTrerangeIds.length > 0) {
                            this.cmTrerangeIds.forEach(val => {
                                if (this.cmTrerangeList.length > 0) {
                                    if (this.cmTrerangeList.filter(item => item.discId == val).length > 0) {
                                        value2.push(this.cmTrerangeList.filter(item => item.discId == val)[0].scopeName)
                                    }
                                }
                            })
                        }
                        this.obj.cmTrerangeValues = value2.toString();
                    }
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        getRanges() {
            // //type 范围类型0.生产范围1.经营范围2.诊疗范围
            this.getQueryScopeByType(1);
            this.getQueryScopeByType(2);
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                if (key.jciId == 50020) {
                    this.salseFormData = key.jurconfigform
                }
                if (key.jciId == 1088678) {
                    for (let index = 0; index < key.jurconfigform.length; index++) {
                        if (key.jurconfigform[index].entityField == 'isDefault') {
                            this.$set(this.descibCusAddress, key.jurconfigform[index].entityField, 0)
                        } else if (key.jurconfigform[index].fieldType == 'number') {
                            this.$set(this.descibCusAddress, key.jurconfigform[index].entityField, 0)
                        } else if (key.jurconfigform[index].fieldType == 'search') {
                            var arr = []
                            if (key.jurconfigform[index].setField) {
                                arr = key.jurconfigform[index].setField.split(",")
                            }
                            arr.forEach(val => {
                                this.$set(this.descibCusAddress, val, "")
                            })
                        } else {
                            this.$set(this.descibCusAddress, key.jurconfigform[index].entityField, "")
                        }
                    }
                }
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1 && key.jurconfigform[index].entityField != 'cmManrange' && key.jurconfigform[index].entityField != 'cmTrerange') {
                        this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                    } else if (key.jurconfigform[index].entityField == 'cmManrange' || key.jurconfigform[index].entityField == 'cmTrerange') {
                        this.dataList.push(key.jurconfigform[index])
                    }
                }
            });

            if (this.componentType != 'GSP') {
                this.tabForm.forEach((item, index) => {
                    if (item.jciId == 50020) {
                        // this.tabForm.splice(index, 1)
                        item.isShowForm = 1
                    }
                })
            }
            var arr = [{ entityField: "cusfinancelinfos" }, { entityField: 'salesDataList' }, { entityField: 'descibCusAddress' }, { entityField: 'cusaddresses' }, { entityField: 'cusbankinfos' }, { entityField: 'cuslicencelinfos' }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
        },
        async getQueryCodeClassifyaArr() {
            let params = { "codeClassify": 2 } // "编号分类0.商品1.供应商2.客户")
            let res = await this.$http.getQueryCodeClassify(params)
            console.log(res)
            this.codeClassify = res.result
        },
        //查询所有证照类型
        async getPartDictionariesData() {
            const res = await this.$http.getPartDictionariesData({ ids: [55] })
            if (res && res.status == 200) {
                res.result.khzzlx.forEach((v) => {
                    v.lityId = v.diValue
                    this.LicensetypeList.push(v)
                })
                // console.log(this.LicensetypeList);
            } else {
                this.$message({
                    type: 'error',
                    message: '查询所有证照类型失败'
                });
            }
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        let _this = this;
        _this.$nextTick(() => {
            _this.openBox();
            _this.getRanges();
        });
        this.imgur()
        this.getCateDictionariesDatas();
        this.getcontrolType()
        this.imgUrl = this.$store.getters.getConfig.imgUrl;
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.baseForm .el-row {
    display: flex;
    flex-wrap: wrap;
}

.btn {
    margin-bottom: 10px;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
    content: "";
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected .check {
    background-color: #409eff;
    border-color: #409eff;
}

.el-select-dropdown.is-multiple
    .el-select-dropdown__item.selected
    .check:after {
    transform: rotate(45deg) scaleY(1);
}

.el-select-dropdown.is-multiple .el-select-dropdown__item .check::after {
    box-sizing: content-box;
    content: "";
    border: 1px solid #fff;
    border-left: 0;
    border-top: 0;
    height: 7px;
    left: 4px;
    position: absolute;
    top: 1px;
    transform: rotate(45deg) scaleY(0);
    width: 3px;
    transition: transform 0.15s ease-in 0.05s;
    transform-origin: center;
}

::v-deep .upload-demo ul {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
}

::v-deep .upload-demo img {
    width: 30px;
    height: 30px;
    margin-left: 0px;
}

::v-deep .upload-demo .el-upload-list--picture .el-upload-list__item {
    width: 86px;
    height: 42px;
    padding: 5px 0px;
    padding-left: 5px;
}

::v-deep .el-upload-list__item-name {
    margin-right: 0;
    font-size: 13px;
}

::v-deep .el-upload-list__item .el-icon-close {
    top: 2px;
    right: 2px;
}

::v-deep .el-upload-list--picture .el-upload-list__item-status-label {
    width: 40px;
    height: 24px;
    right: -20px;
    top: -9px;
}

::v-deep .el-image__error {
    font-size: 13px;
}

::v-deep
    .el-upload-list--picture
    .el-upload-list__item.is-success
    .el-upload-list__item-name {
    line-height: 30px;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item .check {
    display: inline-block;
    position: relative;
    top: 2px;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    box-sizing: border-box;
    width: 14px;
    height: 14px;
    background-color: #fff;
    z-index: 1;
    transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
        background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}

/* 文本超长 */
::v-deep .el-select__tags-text {
    display: inline-block;
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

::v-deep .el-select .el-tag__close.el-icon-close {
    top: -5px;
}

#cmManrange,
#cmTrerange {
    width: 100%;
    display: flex;
    padding-left: 83px;
    margin-bottom: 10px;
}

::v-deep #cmManrange .el-form-item__content,
::v-deep #cmTrerange .el-form-item__content {
    width: 100% !important;
}

::v-deep #cmManrange .el-textarea__inner,
::v-deep #cmTrerange .el-textarea__inner {
    width: 73.2% !important;
    margin-right: 20px;
    font-size: 12px;
}

.cmTitle {
    color: #606266;
    font-size: 14px;
    padding-top: 4px;
}

.cmContent {
    padding-left: 10px;
    width: 90%;
}

.cmButton {
    margin-bottom: 6px;
}

#csDia ::v-deep .el-dialog {
    min-width: 800px;
}

#cmRegaddres,
#cmWareaddress,
#baStoreaddress,
#cmPlace,
#cmRemark {
    width: 100% !important;
}

#cmRegaddres ::v-deep .el-form-item__content,
#cmWareaddress ::v-deep .el-form-item__content,
#baStoreaddress ::v-deep .el-form-item__content,
#cmPlace ::v-deep .el-form-item__content,
#cmRemark ::v-deep .el-form-item__content {
    width: 100% !important;
}

#cmRegaddres ::v-deep .el-textarea__inner,
#cmWareaddress ::v-deep .el-textarea__inner,
#baStoreaddress ::v-deep .el-textarea__inner,
#cmPlace ::v-deep .el-textarea__inner,
#cmRemark ::v-deep .el-textarea__inner {
    width: 62% !important;
}

#cmSocialcode ::v-deep .el-form-item__content,
#cmName ::v-deep .el-form-item__content {
    width: 386px !important;
}

::v-deep .el-image-viewer__close {
    color: #fff;
}

::v-deep .el-input.is-disabled .el-input__inner,
::v-deep .el-textarea.is-disabled .el-textarea__inner {
    background-color: #fff;
    color: #333;
}

::v-deep
    .el-radio-button__orig-radio:disabled:checked
    + .el-radio-button__inner {
    background-color: #ccc;
}

::v-deep .el-radio-button__orig-radio:disabled + .el-radio-button__inner {
    color: #333;
}

.baseForm ::v-deep .el-form-item__content {
    margin-left: 135px !important;
}

.baseForm ::v-deep .el-form-item__label {
    width: 135px !important;
}

.xing {
    position: absolute;
    top: 0;
    left: 5px;
    font-size: 18px;
    font-weight: 800;
}

/* 图片上传样式 */
.uploadList {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 220px;
    list-style: none;
}

.image {
    position: relative;
    width: 40px;
    height: 40px;
    margin-right: 5px;
    margin-bottom: 5px;
    flex-shrink: 0;
    border: 1px solid #f3f3f3;
}

.image:nth-child(5n) {
    margin-right: 0;
}

.del {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 14px;
    z-index: 99;
    cursor: pointer;
}

.del:hover {
    color: #409eff;
}

.image:hover .del {
    display: inline-block;
}

.image_label {
    cursor: pointer;
    padding: 7px 10px !important;
    font-size: 12px !important;
    background-color: #409eff;
    color: #ffffff;
    line-height: 14px;
    margin-right: 5px;
    border-radius: 3px;
}
.image_label1 {
    padding: 5px 10px !important;
}
::v-deep .el-image__error {
    font-size: 7px;
}
</style>
